import "./NotificationLayout.css";
import { useState, useEffect } from "react";
import Instance from "../../Utils/Axios";
import { formatDistanceToNow, format } from "date-fns";
import parse from "html-react-parser";
import PremiumLoader from "../Loader/PremiumLoader";
import useDashboardStore from "../../store/dashboardStore";

export default function NotificationLayout() {
  const { notificationData, notificationUnreadCount, markAsRead, loading: apiLoading, fetchDashboardData } = useDashboardStore();
  const [activeTab, setActiveTab] = useState(1);
  const [expandedIds, setExpandedIds] = useState([]);
  const [error, setError] = useState("");
  const [localLoading, setLocalLoading] = useState(false);

  useEffect(() => {
    if (fetchDashboardData) {
      const intervalId = setInterval(() => {
        fetchDashboardData(true, true);
      }, 5000); // Poll every 5 seconds for real-time updates
      return () => clearInterval(intervalId);
    }
  }, [fetchDashboardData]);

  const toggleExpand = (id) => {
    markAsRead(id);
    if (activeTab === 3) {
      setActiveTab(2);
    }
    setExpandedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleTabChange = (tabId) => {
    setLocalLoading(true);
    setActiveTab(tabId);
    setTimeout(() => {
      setLocalLoading(false);
    }, 500);
  };


  const filteredNotifications = notificationData.filter((data) => {
    if (activeTab === 1) return true; // All
    if (activeTab === 2) return data.read == 1; // Read
    if (activeTab === 3) return data.read != 1; // Unread
    return true;
  });

  const timeAgo = (dateString) => {
    let date = new Date(dateString);
    if (isNaN(date.getTime())) {
      date = new Date(dateString.replace(' ', 'T'));
    }
    
    if (isNaN(date.getTime())) return "";

    const diffDays = (new Date() - date) / (1000 * 60 * 60 * 24);
    if (diffDays > 30) {
      return format(date, "yyyy-MM-dd hh:mm a"); 
    }
    return formatDistanceToNow(date, { addSuffix: true });
  };

  const formatReadOnTime = (dateString) => {
    if (!dateString) return "";
    let date = new Date(dateString);
    if (isNaN(date.getTime())) {
      date = new Date(dateString.replace(' ', 'T'));
    }

    if (isNaN(date.getTime())) return "";

    const diffMins = (new Date() - date) / (1000 * 60);
    if (diffMins > 30) {
      return format(date, "yyyy-MM-dd hh:mm a"); // e.g., 2026-07-02 12:10 PM
    }
    return formatDistanceToNow(date, { addSuffix: true });
  };

  const getSortDate = (item) => {
    let dateStr = item.updatedOn || item.createdOn || "";
    if (activeTab === 2 && item.readOn) {
      dateStr = item.readOn;
    }
    if (!dateStr) return 0;

    let date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      date = new Date(dateStr.replace(' ', 'T'));
    }
    return isNaN(date.getTime()) ? 0 : date.getTime();
  };
  return (
    <>
      <div className="notification_layout">
        {(apiLoading || localLoading) && <PremiumLoader fullPage={false} text="Loading notifications..." />}
        <div className="notification_tabs">
          <h4
            className={`all_tab ${activeTab === 1 ? "tab_active" : ""}`}
            onClick={() => handleTabChange(1)}
            style={{ cursor: "pointer" }}
          >
            All
          </h4>
          <h4
            className={`read_tab ${activeTab === 2 ? "tab_active" : ""}`}
            onClick={() => handleTabChange(2)}
            style={{ cursor: "pointer" }}
          >
            Read
          </h4>
          <h4
            className={`unread_tab ${activeTab === 3 ? "tab_active" : ""}`}
            onClick={() => handleTabChange(3)}
            style={{ cursor: "pointer" }}
          >
            Unread
            {notificationUnreadCount > 0 && (
              <span className="unread_count_badge">
                {notificationUnreadCount}
              </span>
            )}
          </h4>
        </div>
        <div>
          <div className="notifications_list">
            {filteredNotifications.length > 0 ? (
              filteredNotifications
                .slice()
                .sort((a, b) => getSortDate(b) - getSortDate(a))
                .map((data, index) => (
                  <div
                    key={index}
                    className={`notification ${expandedIds.includes(data.id) ? "expanded" : ""}`}
                    onClick={() => toggleExpand(data.id)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="status_container">
                      <div
                        className={
                          data.status === "REJECT" || data.status === "REJECTED"
                            ? "status_rejected"
                            : data.status === "PENDING"
                              ? "status_pending"
                              : data.status === "PUBLISHED"
                                ? "status_published"
                                : data.status === "UPDATED"
                                  ? "status_updated"
                                  : data.status === "OPEN"
                                    ? "status_action"
                                    : data.status === "DELETED"
                                      ? "status_deleted"
                                      : "status_updated"
                        }
                      ></div>
                      {data.read != 1 && (
                        <div className="unread_dot"></div>
                      )}
                    </div>
                    <div className="content">
                      <div className="header_row">
                        <div className="header_left">
                          <h3 className="pr_id_status">
                            PR ID: {data.id} - PR {data.status}
                          </h3>
                          <span className="time_ago">{timeAgo(data.createdOn || data.updatedOn)}</span>
                          {data.read != 1 ? (
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', color: '#e53935', fontSize: '12px', fontWeight: '600', backgroundColor: '#ffebee', padding: '2px 8px', borderRadius: '12px' }}>
                              <svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="10"></circle></svg> Unread
                            </span>
                          ) : (
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', color: '#16a34a', fontSize: '12px', fontWeight: '600' }}>
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg> Read
                            </span>
                          )}
                        </div>
                        <div className={`arrow_icon ${expandedIds.includes(data.id) ? "active" : ""}`}>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 7.5L10 12.5L15 7.5" stroke="#091E42" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                      <h4 className="notification_title">{data.title}</h4>
                      {expandedIds.includes(data.id) && (
                        <div className="description_container">
                          <div className="description_text">{parse(data.description || "")}</div>
                          {data.addNote && (
                            <div className="notification_note">
                              <strong>Note:</strong> {data.addNote}
                            </div>
                          )}
                          {data.read == 1 && (
                            <div className="read_on_info" style={{ marginTop: '16px', fontSize: '13px', color: '#16a34a', display: 'flex', alignItems: 'center', gap: '6px', borderTop: '1px solid #f1f5f9', paddingTop: '12px' }}>
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                              <span>Read{data.readOn ? `: ${formatReadOnTime(data.readOn)}` : ""}</span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ))
            ) : (
              <div className="d-flex gap-2">
                <div
                  className="color_box"
                  style={{ backgroundColor: "#595FDE" }}
                ></div>
                <div className="notification_actions_info">
                  <p className="notification_action">No Notifications yet</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
